
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Building, Award } from 'lucide-react';

const SaasHowItWorks: React.FC = () => {
  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-primary-blue mb-2">How It Works</h2>
          <p className="text-lg text-gray-600">A step-by-step guide to setting up your referral program</p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8">
          <Card className="bg-white shadow-md">
            <CardHeader className="pb-2">
              <div className="bg-primary-blue/10 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <Building className="h-6 w-6 text-primary-blue" />
              </div>
              <CardTitle className="text-xl">Custom Domain and Branding</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600">Create a unique domain and customize the look and feel of your referral program.</p>
            </CardContent>
          </Card>
          
          <Card className="bg-white shadow-md">
            <CardHeader className="pb-2">
              <div className="bg-primary-blue/10 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <Award className="h-6 w-6 text-primary-blue" />
              </div>
              <CardTitle className="text-xl">Award-winning Design</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600">Our referral program is designed to be visually appealing and user-friendly.</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default SaasHowItWorks;
